import { atom } from 'jotai';

export const DEFAULT_CARD_FILTER_STATE = {
    filters: {
        year: '',
        rating: '',
        team: '',
        type: '',
        variation: '',
        position: '',
        canLevelUp: '',
    },
    sort: 'rating',
    sortDir: 'desc',
};

export const userCardsFilterAtom = atom(DEFAULT_CARD_FILTER_STATE);
